import { Grid } from "@mui/material";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import { MenuSection } from "src/business/restaurant/menu";
import { StatCard } from "src/design";
import {
  iconBgSuccess,
  iconColorSuccess,
  iconBgInfo,
  iconColorInfo,
  iconBgPurple,
  iconColorPurple,
} from "src/design/tokens";
import { useTranslation } from "react-i18next";

const iconBgAmber = "#FEF3C7";
const iconColorAmber = "#D97706";

interface Props {
  menu: MenuSection[];
}

export const MenuStatsRow = ({ menu }: Props) => {
  const { t } = useTranslation();

  const allItems = menu.flatMap((s) => s.menuItems);
  const activeItems = menu.filter((s) => s.active).flatMap((s) => s.menuItems);

  const prices = allItems
    .map((i) => parseFloat(i.price))
    .filter((p) => !isNaN(p) && p > 0);
  const avgPrice =
    prices.length > 0
      ? Math.round(prices.reduce((a, b) => a + b, 0) / prices.length)
      : 0;

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          label={t("menu.stats.totalItems")}
          value={allItems.length}
          icon={<ListAltOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgSuccess}
          iconColor={iconColorSuccess}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          label={t("menu.stats.activeItems")}
          value={activeItems.length}
          icon={<CheckCircleOutlineIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgInfo}
          iconColor={iconColorInfo}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          label={t("menu.stats.categories")}
          value={menu.length}
          icon={<FolderOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgPurple}
          iconColor={iconColorPurple}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          label={t("menu.stats.avgPrice")}
          value={`${avgPrice} ${t("menu.currency")}`}
          icon={<SellOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgAmber}
          iconColor={iconColorAmber}
        />
      </Grid>
    </Grid>
  );
};
